/** Auto-generated by scripts/fetch-seo-payload.mjs — do not edit by hand */
export const SEO_PAYLOAD = {
  "generatedAt": "2026-10-06T13:56:33.725Z",
  "source": "supabase",
  "team": {
    "tien": {
      "slug": "tien",
      "name": "Viora (Tien) Tran",
      "role": "Associate",
      "title": "Viora (Tien) Tran — Associate | Dilinh Legal",
      "description": "Advises on corporate structuring, licensing, and real estate transactions, with a focus on foreign investment and FIE compliance."
    },
    "david": {
      "slug": "david",
      "name": "David Lawrence",
      "role": "Of‑Counsel",
      "title": "David Lawrence — Of‑Counsel | Dilinh Legal",
      "description": "Of-Counsel to Dilinh Legal, bringing deep expertise in cross-border transactions, international arbitration, and dispute resolution strategy."
    },
    "denny": {
      "slug": "denny",
      "name": "Denny Cowger",
      "role": "Senior Consultant",
      "title": "Denny Cowger — Senior Consultant | Dilinh Legal",
      "description": "Provides senior consulting support on corporate, M&A, and business advisory matters, with extensive international experience in the Vietnam market."
    },
    "khai": {
      "slug": "khai",
      "name": "Khai Ho",
      "role": "Associate",
      "title": "Khai Ho — Associate | Dilinh Legal",
      "description": "Focuses on foreign investment, market entry, employment of foreign nationals, and arbitration support for international clients."
    },
    "huong": {
      "slug": "huong",
      "name": "Kate (Huong) Nguyen",
      "role": "Associate",
      "title": "Kate (Huong) Nguyen — Associate | Dilinh Legal",
      "description": "Specialises in corporate governance, employment law, and data privacy compliance, advising multinational and foreign-invested clients."
    },
    "thanh": {
      "slug": "thanh",
      "name": "Thanh Phan",
      "role": "Tax Consultant",
      "title": "Thanh Phan — Tax Consultant | Dilinh Legal",
      "description": "Provides specialist tax advisory services, supporting corporate transactions, transfer pricing compliance, and tax dispute resolution."
    },
    "minhbui": {
      "slug": "minhbui",
      "name": "Minh Bui",
      "role": "Junior Associate",
      "title": "Minh Bui — Junior Associate | Dilinh Legal",
      "description": "Supports the legal team across corporate, employment, and regulatory matters, with research and document preparation."
    },
    "diem": {
      "slug": "diem",
      "name": "Phoebe (Diem) Nguyen",
      "role": "Admin Assistant",
      "title": "Phoebe (Diem) Nguyen — Admin Assistant | Dilinh Legal",
      "description": "Manages firm operations, client communications, document processing, and administrative coordination for the team."
    },
    "michael": {
      "slug": "michael",
      "name": "Michael Lee",
      "role": "Partner",
      "title": "Michael Lee — Partner | Dilinh Legal",
      "description": "Michael joined Dilinh in September 2017, bringing over a decade of experience gained at two leading international law firms in Vietnam. His background in inter…"
    },
    "diep": {
      "slug": "diep",
      "name": "Dee (Diep) Hoang",
      "role": "Founder & Partner",
      "title": "Dee (Diep) Hoang — Founder & Partner | Dilinh Legal",
      "description": "Diep founded Dilinh Legal in 2010 with a clear vision: to build a focused Vietnamese boutique that delivers the quality of international firm advice with the a…"
    },
    "minhnguyen": {
      "slug": "minhnguyen",
      "name": "Minh Nguyen",
      "role": "Junior Associate",
      "title": "Minh Nguyen — Junior Associate | Dilinh Legal",
      "description": "Assists with legal research, due diligence, and document drafting across the firm's practice areas."
    },
    "helen": {
      "slug": "helen",
      "name": "Helen (Trang) Nguyen",
      "role": "Partner",
      "title": "Helen (Trang) Nguyen — Partner | Dilinh Legal",
      "description": "Helen (Trang) Nguyen joined Dilinh as an Associate and has been elevated to Partner, reflecting her significant contribution to the firm's growth and her deep…"
    }
  },
  "routes": [
    "/",
    "/practices",
    "/practices/corporate",
    "/practices/licensing",
    "/practices/labour",
    "/practices/privacy",
    "/practices/realestate",
    "/practices/disputes",
    "/team",
    "/toolkits",
    "/updates",
    "/contact",
    "/team/tien",
    "/team/david",
    "/team/denny",
    "/team/khai",
    "/team/huong",
    "/team/thanh",
    "/team/minhbui",
    "/team/diem",
    "/team/michael",
    "/team/diep",
    "/team/minhnguyen",
    "/team/helen"
  ]
};
